import React from 'react';

export default function GlassPanel({ children, className = '', hover = false, ...props }) {
  return (
    <div
      className={`glass-panel ${hover ? 'hover:bg-bb-glassHover hover:border-white/10 transition-all duration-300' : ''} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}